import React, {useEffect, useRef} from 'react'
import {combineClasses} from "components/Layout/Search/Search.Component";

interface ITimer {
  duration: number
  className?: string
  onTimeEnds?: () => void
}

const ONE_SECOND = 1000
const FULL_PROGRESS = 100

const Timer = ({
  className,
  onTimeEnds,
  duration
}: ITimer) => {
  const timerRef = useRef(null)

  useEffect(() => {
    const step = FULL_PROGRESS / duration
    let iteration = 1
    const intervalId = setInterval(() => {
      const progress = Math.floor(iteration * step)

      if (progress >= FULL_PROGRESS) {
        onTimeEnds?.()
      }

      if (timerRef.current) {
        timerRef.current.style.setProperty("--progress", `${progress}%`)
        timerRef.current.setAttribute("aria-valuenow", progress)
      }

      const predicateNextProgress = Math.floor((iteration + 1) * step)

      // ToDo: tu się mogą pojawić problemy ale na razie nie mam jak sprawdzić(nie działa odpowiednio środowisko)
      //  czy potrzeba jest tego zmieniania
      if (predicateNextProgress > FULL_PROGRESS) {
        iteration = 1
      } else {
        iteration++
      }
    }, ONE_SECOND)

    return () => {
      clearInterval(intervalId)
    }
  }, [duration]);

  return (
    <div
      ref={timerRef}
      className={combineClasses("timer", className)}
      role="progressbar"
      aria-valuenow={0}
    />
  );
}

export default Timer



// WEBPACK FOOTER //
// ./src/components/Layout/Timer/Timer.Component.tsx